import { useEffect, useState } from "react";
import API from "../API";
import { generateRandomPassword } from "./utils";
import {ru} from '../data/ru'
import {by} from '../data/by'
import TypeExpert from "./admin/TypeExpert";
import toast from "react-hot-toast";

export default function AddUser({additional,close}) {
	const api = new API()
	let language = localStorage.getItem('lang') === 'ru' ? ru.RoleIdOne : by.RoleIdOne;
	const [password, setPassword] = useState(0)
	const [isValide, setIsValide] = useState()
	const [isExpert, setIsExpert] = useState(false);

	useEffect(() => {
		setPassword(generateRandomPassword())
	}, [])

	const idOrganization = localStorage.getItem('type') === 'Teacher' ? localStorage.getItem('idOrganization') : localStorage.getItem('idO')
	const [form, setForm] = useState({
		idUser: localStorage.getItem('id'),
		nameNewUser: '',
		login: '',
		password: '',
		type: '',
		idOrganization: idOrganization,
		tags: [],
		grade: '',
	});

	const sendResults = (e) => {
		e.preventDefault();
		const typeUser = localStorage.getItem('type') === 'Teacher' ? 'Student' : form['type']
		let resultJSON = {
			'idUser': form['idUser'],
			'nameNewUser': form['nameNewUser'],
			'login': form['login'],
			'password': password,
			'type': typeUser,
			'idOrganization': form['idOrganization'],
			'tags': form['tags'],
			'grade': form['grade'],
		};
		if (typeUser === 'Expert' && form['tags'].length === 0) {
			toast.error('Заполните тэг эксперта!')
			return
		}

		if (isValide && typeUser.length !== 0) {
			api.addUser(form['idUser'], resultJSON).then(data => {
				additional();
				close();
			}).catch(err => {
				console.error('myError: ' + err);
			});
		} else {
			toast.error('Во время добавления произошла ошибка. Пользователь не добавился. Проверте правильность введеных полей!')
		}
	}


	const ChangeSelect = (e) => {
		setForm(current => {
			current.type = e.target.value;
			return current
		})
		if (e.target.value === 'Expert' || e.target.value === 'SuperExpert') {
			setIsExpert(true);
		} else setIsExpert(false);
	}

	const changeTag = (tag) => {
		setForm(current => {
			current.tags = tag;
			return current
		})
	}

	function isValidEmail(email) {
		return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
	}

	function OnChangeLogin(e) {
		if (isValidEmail(e.target.value)) {
			setIsValide(true)
		} else {
			setIsValide(false)
		}
		setForm(current => {
			current.login = e.target.value;
			return current
		})
	}

	const styleNoValided = {
		border: '1px solid red',
		borderColor: 'red'
	}


	const roleSelect = <select placeholder='Выберите'
							   onChange={e => ChangeSelect(e)}
	>

		<option value="">{language.selectRole}</option>
		<option value="Curator">{language.curator}</option>
		<option value="Teacher">{language.teacher}</option>
		<option value="Expert">{language.expert}</option>
		{localStorage.getItem('type') === 'Admin' ? /*только для админа*/
			<>
				<option value="Editor">{language.editor}</option>
				<option value="SuperExpert">Ст. {language.expert}</option>
			</>
			: null
		}
	</select>


	const gradeInput = <>
		<p className='add_field-name'>{language.class}</p>
		<input
			className="add_input"
			placeholder={language.enter + " "+language.class}
			onChange={e => setForm(current => {
				current.grade = e.target.value;
				return current
			})}
		/>
	</>


	return (
		<div className="add">
			<p className='add_text'>{language.addNewSubordinate}</p>

			<form className="add-form d-flex" onSubmit={e => sendResults(e)}>
				<div className='add_field-name'>{language.FIO}</div>
				<input
					className="add_input"
					placeholder={language.enter + ' ' + language.FIO}
					onChange={e => setForm(current => {
						current.nameNewUser = e.target.value;
						return current
					})}
				/>

				<div className='add_field-name'>{language.login}</div>
				<input
					className="add_input"
					placeholder={language.enter + ' ' + language.login}
					onChange={e => OnChangeLogin(e)}
					style={(form.login !== '') ? (isValide ? null : styleNoValided) : {}}
				/>
				{(form.login !== '') ? (isValide ? null :
					<p className={'add_field-name'}>
						{language.loginExample}: {localStorage.getItem('type') === 'Teacher' ?
						'[Фамилия_Имя]@[Название учебного заведения].[Населенный пункт]' : 'example@organization.city'
					}
					</p>) :
					null}
				<div className='add_field-name'>Пароль</div>
				<input
					className="add_input"
					placeholder={language.enter + " Пароль"}
					value={password}
					onChange={e => setForm(current => {
						current.password = e.target.value;
						return current
					})}
				/>
				{localStorage.getItem('type') === 'Teacher' ? gradeInput : null}

				<div className='add_role'>
					{localStorage.getItem('type') !== 'Teacher' ? roleSelect : null}
				</div>
				{isExpert ? <TypeExpert changeTag={changeTag}/> : <></>}
				<button className="add_button"
						value="Отправить"
						disabled={!isValide}
				>{language.buttonAdd}</button>
			</form>
		</div>
	)
}

